<!--
 * @Description: 功能权限设置
 * @Autor: lwq
 * @Date: 2020-07-17 14:23:29
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-31 15:28:22
 * @FilePath: \mrc-base-server-view\src\views\admin_account_manage\modules\funcSet.vue
-->
<template>
  <v-card-text>
    <mrc_ess_mytree ref="roleTree"
                    :uuids="propsParams"
                    :list="treeList"
                    :disabled="disabled"
                    :isload="isload">
    </mrc_ess_mytree>
    <mrc_ess_submitBtn v-if="!disabled"
                       @cancel="cancel"
                       @success="success"
                       :cancelText="cancelText || $t('label_cancel')"
                       :successText="successText || $t('label_submit')"></mrc_ess_submitBtn>
  </v-card-text>
</template>

<script>
// import { func_list } from '@/service/api/role'
import { func_list } from '@/service/api/admin_account_manage'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    propsParams: {
      type: Array,
      default: () => [],
    },
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
  },
  data () {
    return {
      isload: false,
      treeList: [],
      ids: [],
    }
  },
  created () { },
  async mounted () {
    this.isload = false
    await this.getFuncList()
    this.isload = true
  },
  methods: {
    eleTree () {
      return this.$refs.roleTree.getCheckData()
    },
    /**
     * @description: 获取树结构
     * @param {type}
     * @return:
     * @author: lwq
     */

    async getFuncList () {
      const list = await func_list()
      if (list.code == 200) {
        this.treeList = list.data
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    success () {
      this.$emit('success', this.$refs.roleTree.getCheckData())
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped></style>
